<template>
  <div v-show="isModuleViewActiveLocal">

    <div class="vx-row limit-width_fixed-scalable">
      <div class="vx-col mb-3" vs-lg="4" style="margin-top:8px">
        <span style="font-size: 18pt;font-weight: 100;color:white;">
          You have selected:
        </span>
      </div>

      <div class="vx-col" vs-lg="4" style="margin:auto">
        <vx-card v-if="!isStudent" class="glow-effect_dark limit-width_fixed card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span><feather-icon class="pt-1" icon="MessageCircleIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button size="large"
                        class="w-full button-text__left-align glow-effect_primary__hover back-button bg-color"
                        style="border-radius:0 7px 7px 0"
                        type="filled"
                        color=""
                        @click="backToPickLanguage">
              <span id="backArrow"><feather-icon class="pt-1 back-icon__hover-only" icon="ArrowLeftIcon" svg-classes="stroke-current"></feather-icon></span>
              {{ selectedLanguage }}
            </vs-button>
          </vx-input-group>
        </vx-card>
        <vx-card v-if="!isStudent"  class="mt-3 glow-effect_dark limit-width_fixed card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span><feather-icon class="pt-1" icon="BookmarkIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button size="large"
                        class="w-full button-text__left-align glow-effect_primary__hover back-button bg-color"
                        style="border-radius:0 7px 7px 0"
                        type="filled"
                        color=""
                        @click="backToPickGrade">
              <span id="backArrow"><feather-icon class="pt-1 back-icon__hover-only" icon="ArrowLeftIcon" svg-classes="stroke-current"></feather-icon></span>
              {{ selectedGrade.name }}
            </vs-button>
          </vx-input-group>
        </vx-card>
        <vx-card class="mt-3 glow-effect_dark limit-width_fixed card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <img height="25" :src="selectedSubject.icon" />
              </div>
            </template>

            <vs-button size="large"
                        class="w-full button-text__left-align glow-effect_primary__hover back-button bg-color"
                        style="border-radius:0 7px 7px 0"
                        type="filled"
                        color=""
                        @click="backToPickSubject">
              <span id="backArrow"><feather-icon class="pt-1 back-icon__hover-only" icon="ArrowLeftIcon" svg-classes="stroke-current"></feather-icon></span>
              {{ selectedSubject.name }}
            </vs-button>
          </vx-input-group>
        </vx-card>
      </div>
    </div>

    <ul style="margin-top: 10px;flex-wrap: wrap;">
      <div class="limit-width_fixed-scalable" style="text-align: left;">
        <li>
          <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 277px">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text glow-effect_bg-color__blend bg-color">
                  <span><feather-icon class="pt-1" icon="CodesandboxIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button
                        :disabled="true"
                        size="large"
                        class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-lookalike text__school-tertiary-color bg-color"
                        type="filled"
                        color="">
                Select a Module
              </vs-button>
            </vx-input-group>
          </vx-card>
        </li>
      </div>

      <li v-for="(_module, modIndex) in modules.filter(x => !x.libraryResourceTypeId)" :key="modIndex" class="mb-4">
        <vx-card class="glow-effect_dark limit-width_fixed-scalable card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <vs-button v-if="_module.hasNewContent" :disabled="true" id="new-content" size="small" radius color="#4e5c9a" type="filled" icon-pack="feather" icon="icon-star" class="button__fully-opaque glow-effect_light"></vs-button>
              <div class="prepend-text input-group_prepend-slot-bg" style="border-radius: 5px 0 0 5px !important;">
                <span><feather-icon class="pt-1" icon="CodesandboxIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button size="large"
                       class="w-full button__fully-opaque button-text__left-align glow-effect_primary school-primary_gradient"
                       style="border-radius:0 7px 7px 0;"
                       @click="selectModule(_module)">
              {{ _module.name }}
            </vs-button>
            <span v-if="modules.filter(x => !x.libraryResourceTypeId).length != 1 && !isStudent" id="manage-topic-fab" class="WTF">
                <div class="fab_inline--button">
                      <div class="float-btn-group">
                        <button
                          class="btn-float btn-triger input-group_prepend-slot-bg"
                          @click="openActions($event)"
                          :id="`subject-${_module.id}`"

                        >
                          <i
                            class="icon feather icon-more-horizontal text-white"
                          />
                        </button>
                      <div class="btn-list">
                          <a
                           v-show="modIndex != 0"
                            class="btn-float dc_dark-purple description glow-effect_dark"
                            @click="moveIndexUp(modIndex)"
                          >
                            <i
                              class="icon feather icon-arrow-up-circle text-white"
                            ></i>
                          </a>
                          <a
                            v-show="false"
                            class="btn-float dc_dark-purple description glow-effect_dark"
                            @click="editTask(_module)"
                          >
                            <i class="icon feather icon-edit text-white"></i>
                          </a>
                          <a
                             v-show="modIndex < modules.filter(x => !x.libraryResourceTypeId).length - 1"
                            class="btn-float _subject-purple description glow-effect_dark"
                            @click="moveIndexDown(modIndex)"
                          >
                            <i
                              class="icon feather icon-arrow-down-circle text-white"
                            ></i>
                          </a>
                          <a
                            v-show="false"

                            class="btn-float dc_dark-purple description glow-effect_dark"
                            @click="deleteTask(_module)"
                          >
                            <i
                              class="icon feather icon-trash-2 text-danger"
                            ></i>
                          </a>
                        </div>
                      </div>
                      </div>

                    </span>  
          </vx-input-group>
        </vx-card>       
      </li>

      <div v-if="modules.filter(x => x.libraryResourceTypeId).length > 0" class="limit-width_fixed-scalable" style="text-align: left;">
        <li>
          <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 277px">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text glow-effect_bg-color__blend bg-color">
                  <span><feather-icon class="pt-1" icon="PaperclipIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button
                        :disabled="true"
                        size="large"
                        class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-lookalike text__school-tertiary-color bg-color"
                        type="filled"
                        color="">
                Prescribed Material
              </vs-button>
            </vx-input-group>
          </vx-card>
        </li>
      </div>

      <li v-for="(_resource, index) in modules.filter(x => x.libraryResourceTypeId)" :key="index + '_r'" class="mb-4">
        <vx-card class="glow-effect_dark limit-width_fixed-scalable card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg" style="border-radius: 5px 0 0 5px !important;">
                <span v-if="_resource.libraryResourceTypeId == 1"><feather-icon class="pt-2" icon="BookOpenIcon" svg-classes="stroke-current"></feather-icon></span>
                <span v-else-if="_resource.libraryResourceTypeId == 2"><feather-icon class="pt-2" icon="VideoIcon" svg-classes="stroke-current"></feather-icon></span>
                <span v-else><feather-icon class="pt-2" icon="MusicIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button size="large"
                      class="w-full button__fully-opaque button-text__left-align glow-effect_primary school-primary_gradient"
                      style="border-radius:0 7px 7px 0;"
                      @click="selectResource(_resource)">
              {{ _resource.name }}
            </vs-button>           
          </vx-input-group>
        </vx-card>
      </li>


      <p v-show="showComingSoon" style="color:white;font-weight:500;font-size:16px;padding-top:5px">Watch this space! Content coming soon...</p>
    </ul>

    <div>
      <vs-popup title="Information" id="resource-popup" :active.sync="resourcePopupActive">
        <div class="vx-row">
          <div class="vx-col sm:w-full md:w-1/2 lg:w-1/3 xl:w-1/3">
            <img :src="selectedResource.coverPageUrl" class="reflection_bottom" style="width: 100%;border-radius: 15px;"/>
          </div>
          <div class="vx-col sm:w-full md:w-1/2 lg:w-2/3 xl:w-2/3">
          <div class="vx-row">
              <div class="vx-col w-full">
                <div v-if="selectedResource.libraryResourceTypeId == 1">
                  <svg xmlns="http://www.w3.org/2000/svg" style="color: white" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-book-open"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path></svg>
                </div>
                <div v-if="selectedResource.libraryResourceTypeId == 2">
                  <svg xmlns="http://www.w3.org/2000/svg" style="color: white" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-video"><polygon points="23 7 16 12 23 17 23 7"></polygon><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect></svg>
                </div>
                <div v-if="selectedResource.libraryResourceTypeId == 3">
                  <svg xmlns="http://www.w3.org/2000/svg" style="color: white" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-music"><path d="M9 18V5l12-2v13"></path><circle cx="6" cy="18" r="3"></circle><circle cx="18" cy="16" r="3"></circle></svg>
                </div>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <h3>{{ selectedResource.genreName }}</h3>
              </div>
            </div>
            <div class="vx-row mt-2">
              <div class="vx-col w-full">
                <h1 class="text__school-font-color"><strong>{{ selectedResource.title }}</strong></h1>
              </div>
            </div>
            <div class="vx-row mt-2">
              <div class="vx-col w-full">
                <h5 class="text-white"><strong>{{ selectedResource.producer || selectedResource.author }}</strong></h5>
              </div>
            </div>
            <div class="vx-row mt-2">
              <div class="vx-col w-full">
                <p class="text-white" style="text-align: justify;">{{ selectedResource.summary }}</p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="selectedResource.libraryResourceTypeId == 1 || selectedResource.libraryResourceTypeId == 2" class="vx-row">
          <vs-spacer />
          <div class="vx-col">
            <vs-button
              ref="search"
              class="custom-button_library mt-2 vs-con-loading__container school-primary_gradient glow-effect_tertiary"
              @click="viewResource">
              <img style="float:left; margin-left:-7px; margin-right:5px; margin-top:-2px; height:25px" src="https://lateralscaffolding.blob.core.windows.net/resources/icon-view-custom.png"/>
              <strong>View</strong>
            </vs-button>
          </div>
        </div>
        <div v-else class="vx-row">
          <div class="vx-col w-full">
            <div id="podcast-container" ref="podcastViewer" class="xs:w-full sm:w-full md:w-1/2 lg:w-2/3 xl:w-2/3 float-right vs-con-loading__container">
              <video id="podcastPlayer" class="media-video-player card-video" controls />
            </div>
          </div>
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import Plyr from 'plyr';
import 'plyr/dist/plyr.css';
export default {
  props: {
    isModuleViewActive: {
      required: false,
    },
    isStudent: {
      type: Boolean,
      required: false
    },
    selectedLanguage: {
      type: String,
      required: false
    },
    selectedGrade: {
      type: Object,
      required: false
    },
    selectedSubject: {
      type: Object,
      required: true
    },
    modules: {
      type: Array,
      required: false
    },
    showComingSoon: {
      required: false
    }
  },
  components: {
    Plyr
  },
  data() {
    return {
      selectedResource: {},
      resourcePopupActive: false,
      podcastPlayer: null,
      fileExt: "",
      source: [],
      selectedElement: "",
    }
  },
  computed: {
    isModuleViewActiveLocal: {
      get() {
        return this.isModuleViewActive;
      }
    }
  },
  watch: {
    resourcePopupActive: function(val) {
      if (!val) {
        this.destroyPlayer();
      }
    }
  },
  methods: {
    selectModule(module) {
      var self = this;
      self.$emit("moduleSelected", module);
    },
    selectResource(resource) {
      var self = this;

      self.selectedResource = {};
      self.selectedResource = resource;
      self.resourcePopupActive = true;

      if (self.selectedResource.libraryResourceTypeId == 3) {
        self.playPodcast();
      }
    },
    viewResource() {
      var self = this;
      self.resourcePopupActive = false;

      if(self.isStudent) {
        var selectedData = {
          selectedSubject: self.selectedSubject
        };
      }
      else {
        var selectedData = {
          selectedLanguage: self.selectedLanguage,
          selectedGrade: self.selectedGrade,
          selectedSubject: self.selectedSubject
        };
      }

      localStorage.setItem("selectedData", JSON.stringify(selectedData));

      setTimeout(function() {
        if (self.selectedResource.libraryResourceTypeId == 1) {
          self.$router.push({ name: 'DocumentViewer', query: { id: self.selectedResource.id, url: self.selectedResource.url, orig: 'mod' } });
        }
        else if (self.selectedResource.libraryResourceTypeId == 2) {
          self.$router.push({ name: 'HLSVideoViewer', query: { id: self.selectedResource.id, url: self.selectedResource.url, orig: 'mod' } });
        }
      }, 200)
    },
    destroyPlayer() {
      var self = this;
      if(self.podcastPlayer)
        self.podcastPlayer.destroy();
    },
    backToPickLanguage() {
      this.$emit("backToPickLanguage");
    },
    backToPickGrade() {
      this.$emit("backToPickGrade");
    },
    backToPickSubject() {
      this.$emit("backToPickSubject");
    },
    playPodcast() {
      var self = this;
      var podcastUrl = self.selectedResource.url;

      self.podcastPlayer = new Plyr('#podcastPlayer', {
        autoplay: false
      });
      self.showLoadingOnElement("podcastViewer", 1, "material");

      var counter = 0;
      self.podcastPlayer.on('canplay', event => {
        counter++;
        if(counter == 2){
          self.$vs.loading.close(self.$refs.podcastViewer.$el);
        }
      });

      self.fileExt = podcastUrl.substr(podcastUrl.lastIndexOf(".") + 1);
      self.source = [{ type: "audio/" + self.fileExt, src: podcastUrl }];
      self.podcastPlayer.source = {
        type: 'audio',
        sources: self.source
      };
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
     closebtnGroups(){
      var self = this;
      var openBtnGroups = [];
      openBtnGroups = document.getElementsByClassName('float-btn-group open');
      openBtnGroups.forEach(element => {
        element.classList.remove("open");
      });
    },
    openActions(e) {
      this.closebtnGroups();
      this.fabElement= e.target.closest(".float-btn-group");

      if(!this.selectedElement || this.selectedElement != this.fabElement.firstChild.id){
        this.fabElement.classList.add('open')
        this.selectedElement = this.fabElement.firstChild.id;
      }
      else if(this.selectedElement == this.fabElement.firstChild.id){
        this.fabElement.classList.remove('open');
        this.selectedElement = "";
      }
      
    },
    moveIndexUp(moduleIndex){
      var self = this;
      var moduleId = self.modules.filter(x => !x.libraryResourceTypeId)[moduleIndex].id; 
      var swapModuleId = self.modules.filter(x => !x.libraryResourceTypeId)[moduleIndex - 1].id;
      var onSuccess = response =>{
        this.$emit('changeModuleCategoryUp',moduleIndex);
        this.closebtnGroups();
        this.selectedElement = "";
      }
    
      var onFinally = response =>{
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: `Order changed`,
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-info'
        });
      }
    
      self.$ajaxGet(self, `ModuleCategory/ChangeIndex?originalId=${moduleId}&swapCategory=${swapModuleId}` , onSuccess, onFinally);
    },
    moveIndexDown(moduleIndex){
      var self = this;

      var moduleId = self.modules.filter(x => !x.libraryResourceTypeId)[moduleIndex].id; 
      var swapModuleId = self.modules.filter(x => !x.libraryResourceTypeId)[moduleIndex + 1].id;
      var onSuccess = response =>{
        this.$emit('changeModuleCategoryDown',moduleIndex);
        this.closebtnGroups();
        this.selectedElement = "";
      }
    
      var onFinally = response =>{
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: `Order changed`,
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-info'
        });
      }
    
      self.$ajaxGet(self, `ModuleCategory/ChangeIndex?originalId=${swapModuleId}&swapCategory=${moduleId}` , onSuccess, onFinally);
    },
  }
};
</script>
